import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import Vant, { Toast, Dialog, Loading } from 'vant';
import 'xgplayer/dist/index.min.css';
import 'swiper/css/swiper.css'
import 'vant/lib/index.css';
import './assets/css/global.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(Toast);
Vue.use(Vant);
Vue.use(VueAwesomeSwiper);

// 封装全局工具函数
const globalUtils = {
  // 文字提示
  showToast(message, duration = 1500) {
    Toast({
      message,
      duration
    });
  },

  // 显示加载提示
  showLoading(message = '加载中...') {
    this.loadingInstance = Toast.loading({
      message,
      duration: 1000,
      forbidClick: true
    });
  },

  // 隐藏加载提示
  hideLoading() {
    if (this.loadingInstance) {
      Toast.clear();
      this.loadingInstance = null;
    }
  },

  // 显示确认弹框
  showConfirm(options) {
    const { title = '提示', message = options } = options;
    return Dialog.confirm({ title, message, confirmButtonColor: '#2A70F2' });
  },

  // 带头部的确认弹框
  showTitlefirm(titles, options) {
    const { title = titles, message = options } = options;
    return Dialog.confirm({ title, message, confirmButtonColor: '#2A70F2' });
  }
};

Vue.prototype.$utils = globalUtils;

// 设置每次路由跳转后自动滚动到页面顶部
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');